<ng-container *ngIf="data$ | async as data">
  <div class="news-page-wrapper">
    <div class="viewAll">
      <a [routerLink]="'/news'">
        <i class="material-icons">keyboard_arrow_left</i> {{ 'newsArticles.backToNews' | cxTranslate }}
      </a>
    </div>
    <div class="article-wrapper">
      <div *ngIf="data?.image" class="article-image"><cx-media [container]="data.image"></cx-media></div>
      <div class="article-details">
        <div class="article-category">
          <ng-container *ngIf="category$ | async as category">
            {{ category.name }}
          </ng-container>
        </div>
        <div class="article-title">{{ data.title }}</div>
        <div class="article-content" [innerHTML]="data.content | safeHtml"></div>
      </div>
    </div>
  </div>
</ng-container>
